import React from 'react';
import { useHistory } from 'react-router-dom';
import { appRoutes } from '../../../routes/routes';
import { Text, textVariantsEnum, fontWeightEnum } from '@/components/Text';
import { JiraCard } from './JiraCard.component';
import styles from './JiraDetailPage.module.scss';

export const JiraDetailPage = () => {
  const history = useHistory();

  return (
    <div className={styles.page}>
      <button
        className={styles.backBtn}
        onClick={() => history.push(appRoutes().integrations)}
      >
        ← Back to Integrations
      </button>

      <div className={styles.pageHeader}>
        <div className={styles.headerLeft}>
          <div className={styles.logoMark}>J</div>
          <div className={styles.titleBlock}>
            <Text
              variant={textVariantsEnum.Header}
              fontWeight={fontWeightEnum.Semibold}
            >
              Jira
            </Text>
            <Text
              variant={textVariantsEnum.Text_13}
              fontWeight={fontWeightEnum.Normal}
              color="gray-600"
            >
              Import Jira project tasks into Prodaff for unified task
              management.
            </Text>
          </div>
        </div>
      </div>

      <div className={styles.panels}>
        <JiraCard />
      </div>
    </div>
  );
};
